module.exports = __webpack_public_path__ + "static/media/patrick-tomasso.998bf38d.jpg";